import { render, staticRenderFns } from "./CommunityEndowment.vue?vue&type=template&id=813f6136&scoped=true&"
import script from "./CommunityEndowment.vue?vue&type=script&lang=js&"
export * from "./CommunityEndowment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813f6136",
  null
  
)

export default component.exports